"use strict";
exports.__esModule = true;
var BroadcastMessage = /** @class */ (function () {
    function BroadcastMessage(allGroups) {
        this._id = '';
        this.title = '';
        this.message = '';
        this.everyoneCanSee = true;
        this.alwaysShowMessage = true;
        this.isActive = true;
        this.startDate = this.today;
        this.endDate = this.afterTwoWeeks;
        this.showOnce = false;
        this.groups = {};
        this.allGroups = allGroups;
        this.mapGroups(allGroups, true);
    }
    Object.defineProperty(BroadcastMessage.prototype, "today", {
        get: function () {
            // return new Date().toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
            return new Date();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(BroadcastMessage.prototype, "afterTwoWeeks", {
        get: function () {
            var startDateObj = new Date(); // Current date
            startDateObj.setDate(startDateObj.getDate() + 14); // Add 14 days / 2 weeks
            // return startDateObj.toLocaleString('en-US', { timeZone: 'America/Los_Angeles' });
            return startDateObj;
        },
        enumerable: true,
        configurable: true
    });
    BroadcastMessage.prototype.updateExpiry = function () {
        this.isActive = true;
        this.startDate = this.today;
        this.endDate = this.afterTwoWeeks;
        this.isExpired = false;
    };
    BroadcastMessage.prototype.mapGroups = function (groupList, state) {
        var gs = this.groups;
        groupList.forEach(function (g) {
            gs[g._id] = state;
        });
    };
    BroadcastMessage.prototype.pareseToLocale = function (date) {
        var parsedDate = new Date(date);
        return parsedDate.toISOString().split('T')[0]; // Outputs 'YYYY-MM-DD'
    };
    /* parseToInput(date) {
        const parsedDate = new Date(date);
        return new Date(parsedDate.getFullYear(), parsedDate.getMonth(), parsedDate.getDate());
    } */
    BroadcastMessage.prototype.parseToInput = function (date) {
        var parsedDate = new Date(date);
        return new Date(parsedDate.getUTCFullYear(), parsedDate.getUTCMonth(), parsedDate.getUTCDate());
    };
    /* parseToUTC(selectedDate) {
        const date = new Date(selectedDate);
        const adjustedDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        return adjustedDate.toISOString().split('T')[0];
    } */
    BroadcastMessage.prototype.parseToUTC = function (selectedDate) {
        var date = new Date(selectedDate);
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())).toISOString().split('T')[0];
    };
    BroadcastMessage.prototype.mapGroupsById = function (groupList, state) {
        var gs = this.groups;
        groupList.forEach(function (gid) {
            gs[gid] = state;
        });
    };
    BroadcastMessage.prototype.onChangeEveryoneCanSee = function () {
        this.mapGroups(this.allGroups, this.everyoneCanSee);
    };
    BroadcastMessage.prototype.onChangeGroupState = function () {
        var _this = this;
        var notChecked = this.allGroups.find(function (group) {
            return !_this.groups[group._id];
        });
        this.everyoneCanSee = notChecked ? false : true;
    };
    BroadcastMessage.prototype.loadFromDbFormat = function (messageJson) {
        this._id = messageJson._id;
        this.title = messageJson.title;
        this.message = messageJson.message;
        this.everyoneCanSee = messageJson.everyoneCanSee;
        this.alwaysShowMessage = messageJson.alwaysShowMessage;
        this.lastModifyUsername = messageJson.lastModifyUsername;
        this.lastModifyTime = messageJson.lastModifyTime;
        this.isActive = messageJson.isActive != undefined ? messageJson.isActive : true;
        this.startDate = messageJson.startDate != undefined ? this.parseToInput(messageJson.startDate) : this.today;
        this.endDate = messageJson.endDate != undefined ? this.parseToInput(messageJson.endDate) : this.afterTwoWeeks;
        this.isExpired = messageJson.isExpired;
        this.showOnce = messageJson.showOnce != undefined ? messageJson.showOnce : false;
        this.mapGroups(this.allGroups, messageJson.everyoneCanSee);
        this.mapGroupsById(messageJson.groups, true);
    };
    BroadcastMessage.prototype.toDbFormat = function () {
        var _this = this;
        return {
            _id: this._id,
            title: this.title,
            message: this.message,
            isActive: this.isActive,
            startDate: this.startDate ? this.parseToUTC(this.startDate) : null,
            endDate: this.endDate ? this.parseToUTC(this.endDate) : null,
            everyoneCanSee: this.everyoneCanSee,
            alwaysShowMessage: this.alwaysShowMessage,
            showOnce: this.showOnce,
            groups: this.everyoneCanSee ? [] : this.allGroups.filter(function (g) { return _this.groups[g._id]; }).map(function (g) { return g._id; })
        };
    };
    return BroadcastMessage;
}());
exports["default"] = BroadcastMessage;
//# sourceMappingURL=broadcast-message.js.map


// WEBPACK FOOTER //
// ./app/widgets/management/broadcast-messages/app/js/logic/broadcast-message.js